import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import MachineFormModal from "./MachineFormModal";
import config from "../../config";
import { toast } from "react-toastify";
import Layout from "../../components/layouts/Main";
import { FaArrowRight } from "react-icons/fa";

const MachineList = () => {
    const [machines, setMachines] = useState([]);
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const fetchMachines = async () => {
        const res = await axios.get(`${config.API_BASE_URL}/machines`);
        setMachines(res.data);
    };

    const fetchProducts = async () => {
        const res = await axios.get(`${config.API_BASE_URL}/products?populateUnit=true`);
        setProducts(res.data);
    };

    useEffect(() => {
        fetchMachines();
        fetchProducts();
    }, []);

    const handleSave = async (data) => {
        try {
            await axios.post(`${config.API_BASE_URL}/machines`, data);
            toast.success("Machine added.");
            fetchMachines();
            setShowModal(false);
        } catch (err) {
            toast.error("Failed to add machine.");
        }
    };

    return (
        <Layout>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Machine</li>
                </ol>
            </nav>

            <Row className="gy-3">
                <Col className="col"><h2>Machines</h2></Col>
                <Col className="text-end col-auto">
                    <div className="d-flex justify-content-end flex-wrap gap-2">
                        <Button onClick={() => setShowModal(true)}>+ Add Machine</Button>
                    </div>
                </Col>
            </Row>

            <Container fluid className="my-4">

                <Row xs={1} sm={2} md={3} xl={4} className="g-3">
                    {machines.map(machine => (
                        <Col key={machine._id}>
                            <Card className="h-100 shadow-sm">
                                <Card.Body>
                                    <Card.Title className="d-flex justify-content-between align-items-center mb-0">
                                        <span>{machine.name}</span>
                                        <Link to={`/machines/${machine._id}`} className="text-primary">
                                            <FaArrowRight />
                                        </Link>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <MachineFormModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    onSave={handleSave}
                    products={products}
                />
            </Container>
        </Layout>
    );
};

export default MachineList;
